import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import { Transform } from 'class-transformer';
import { TranslationSetting } from './../../overrides/model/TranslationSetting.js';
import { LandingPageBlock } from './../../overrides/model/LandingPageBlock.js';
import { LandingPageExtra } from './../../overrides/model/LandingPageExtra.js';
import type { Constructor } from '@whispli/types';

export class __LandingPage extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly id: string = '';
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly name!: string;
  /**
   * @deprecated For backwards-compatibility only. Use isLive
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private is_live!: boolean;

  @Expose({groups: ['client']})
  public get isLive() {
    return this.is_live
  }

  public set isLive(value) {
    this.is_live = value
  }

  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly locale!: string;
  @Expose({ groups: ['client', 'server'] })
  @Type(() => Object)
  public readonly slug!: string | null;
  /**
   * @deprecated For backwards-compatibility only. Use primaryColor
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private primary_color!: string | null;

  @Expose({groups: ['client']})
  public get primaryColor() {
    return this.primary_color
  }

  public set primaryColor(value) {
    this.primary_color = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use secondaryColor
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private secondary_color!: string | null;

  @Expose({groups: ['client']})
  public get secondaryColor() {
    return this.secondary_color
  }

  public set secondaryColor(value) {
    this.secondary_color = value
  }

  @Expose({ groups: ['client', 'server'] })
  @Type(() => Object)
  public readonly password!: string | null;
  /**
   * @deprecated For backwards-compatibility only. Use explanatoryNote
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private explanatory_note!: string | null;

  @Expose({groups: ['client']})
  public get explanatoryNote() {
    return this.explanatory_note
  }

  public set explanatoryNote(value) {
    this.explanatory_note = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use mobileDeepLink
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private mobile_deep_link!: string | null;

  @Expose({groups: ['client']})
  public get mobileDeepLink() {
    return this.mobile_deep_link
  }

  public set mobileDeepLink(value) {
    this.mobile_deep_link = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use translationSettings
   */
  @Type(() => TranslationSetting)
  @Expose({groups:["server"]})
  private translation_settings!: (TranslationSetting)[];

  @Expose({groups: ['client']})
  public get translationSettings() {
    return this.translation_settings
  }

  public set translationSettings(value) {
    this.translation_settings = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use landingPageBlocks
   */
  @Type(() => LandingPageBlock)
  @Expose({groups:["server"]})
  private landing_page_blocks!: (LandingPageBlock)[];

  @Expose({groups: ['client']})
  public get landingPageBlocks() {
    return this.landing_page_blocks
  }

  public set landingPageBlocks(value) {
    this.landing_page_blocks = value
  }

  @Type(() => LandingPageExtra)
  @Expose({ groups: ['client', 'server'] })
  public readonly extra!: LandingPageExtra | null;
  /**
   * @deprecated For backwards-compatibility only. Use createdAt
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private created_at!: string;

  @Expose({groups: ['client']})
  public get createdAt() {
    return this.created_at
  }

  public set createdAt(value) {
    this.created_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use updatedAt
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private updated_at!: string;

  @Expose({groups: ['client']})
  public get updatedAt() {
    return this.updated_at
  }

  public set updatedAt(value) {
    this.updated_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use archivedAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private archived_at!: string | null;

  @Expose({groups: ['client']})
  public get archivedAt() {
    return this.archived_at
  }

  public set archivedAt(value) {
    this.archived_at = value
  }
}
export type LandingPage = Omit<__LandingPage, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'is_live' | 'primary_color' | 'secondary_color' | 'explanatory_note' | 'mobile_deep_link' | 'translation_settings' | 'landing_page_blocks' | 'created_at' | 'updated_at' | 'archived_at'>
export const LandingPage = __LandingPage as any as Constructor<LandingPage>
